import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';
import { api } from '@/utils/api';

// Definimos el tipo de estado para `kpis`
interface Kpi {
  [key: string]: any;
}

interface KpisState {
  fetching: boolean;
  array: Kpi[];
  current: Record<string, any>;
  error?: string;
}

// Estado inicial de `kpis`
const initialState: KpisState = {
  fetching: false,
  array: [],
  current: {},
};

const kpisSlice = createSlice({
  name: 'kpi',
  initialState,
  reducers: {
    getKpi(state) {
      state.fetching = true;
    },
    getKpiSuccess(state, action: PayloadAction<Kpi[]>) {
      state.fetching = false;
      state.array = action.payload;
    },
    getKpiError(state, action: PayloadAction<string>) {
      state.fetching = false;
      state.error = action.payload;
    },
  },
});

export const { getKpi, getKpiSuccess, getKpiError } = kpisSlice.actions;
export default kpisSlice.reducer;

// Thunk para obtener los KPIs
export const getKpisAction = (id: string) => async (dispatch: AppDispatch) => {
  if (!id) return;
  dispatch(getKpi());
  try {
    const res = await api.get(
      `${import.meta.env.VITE_APP_BASE_URL}/kpis/all/today/${id}`,
    );
    dispatch(getKpiSuccess(res.data));
  } catch (err: any) {
    console.error(err);
    dispatch(getKpiError(err.response?.message || 'Error desconocido'));
  }
};
